import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/views/Home.vue'
import StepService from '@/views/Step/Service.vue'
import StepTeam from '@/views/Step/Team.vue'
import StepDate from '@/views/Step/Date.vue'
import Booking from '@/views/Booking.vue'
import BookingConfirm from '@/views/BookingConfirm.vue'
import AppointmentDetail from '@/views/AppointmentDetail.vue'
import Fallback404 from '@/views/404.vue'

export const routes = [
  {
    path: '/',
    component: Home
  },

  {
    path: '/:accountSlug/stepService',
    name : 'stepService',
    component: StepService
  },
  {
    path: '/:accountSlug/stepTeam',
    name : 'stepTeam',
    component: StepTeam
  },
  {
    path: '/:accountSlug/stepDate',
    name : 'stepDate',
    component: StepDate
  },
  {
    path: '/:accountSlug/booking',
    name : 'booking',
    component: Booking
  },

  {
    path: '/:accountSlug/confirm',
    name : 'confirm',
    component: BookingConfirm
  },

  {
    path: '/:accountSlug/appointmentDetail',
    name : 'appointmentDetail',
    component: AppointmentDetail
  },

  {
    path: '/*',
    component: Fallback404
  },
]
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes
})

export default router
